import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import RichtextEditor from '../../../../Core/TextEditor/RichtextEditor'
const Tab1 = ({ brand, setBrand, description, setDescription }) => {
  const [content, setContent] = useState('');
  // console.log("content", content);
  if (content) {
    setDescription(content)
  }

  return (
    <div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <Input
              id="BrandName"
              label="Brand Name"
              style={{ height: "30px" }}
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <RichtextEditor  content={content} setContent={setContent} />
            {/* <Textarea
            id="BrandDescription"
            style={{
              height: "38px",
              border: "",
            }}
            label="Description"
            value={description}
            onChange={(e)=>setDescription(e.target.value)}
          /> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tab1